import React from "react";
import '../Styles/AdminSignIn.scss';
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Session from 'react-session-api';

function AdminSignIn() {
   const navigate = useNavigate();

   const [adminError, setAdminError] =  useState('')

   const [userName, setUserName] = useState('');
   const [passWord, setPassWord] = useState('')
   const handleSubmit = async (event) => {
      event.preventDefault()
      try {

         if(userName === 'admin@registration.billriceranch.com' && passWord === 'AdminTools@1953')
         {

            const apiResponse2 = await fetch('/api/login', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               email: userName,
               password: passWord
            })
         })

         console.log("Here's response",apiResponse2.ok.toString())
         const loginResult = await apiResponse2.json();

         if (apiResponse2.status === 400 || apiResponse2.status === 500) {
            console.log("Here is the error)")
            throw new Error(loginResult.errors[0].msg);
            
         }

         Session.set("isAuth", apiResponse2.ok.toString())
         Session.set("accountType", "admin")
         // Display create individual review page
         navigate('/administration', {

         });
         }
         else 
         {
            throw new Error("Incorrect Admin Credentials Entered");
         }
      } catch (error) {
        setAdminError(error.message); 
      }
   }


   return (
      <div className="adminSignInContent">
         <div className="adminSignInContainer">
            <div className="adminSignInTitle">
               Admin Tools For Online Registration
            </div>
            <div className="adminSignInDescription">
               View week and camper information and manage payments.<br></br><br></br><br></br>
            </div>
            <div className="adminSignInForm">
               <form>
                  <div className="adminSignInUserName">
                     <label for="emailInput">User Name</label>
                     <input className="adminInput" type="text" name='adminUserNameInput' value={userName} onChange={event => setUserName(event.target.value)} />
                  </div>

                  <div className="adminSignInPassword">
                     <label for="emailInput">Password</label>
                     <input className="adminInput" type="password" name='adminUserName' value={passWord} onChange={event => setPassWord(event.target.value)}/>
                  </div>
                  <div style={{ color: 'red', margin: '10px, 0', fontFamily: 'Sen'}}>{adminError}</div>
                  <div className="adminSignInSignInButton">
                     <button onClick={(event) => (handleSubmit(event))}>
                        Sign In
                     </button>
                  </div>
               </form>


            </div>

         </div>
      </div>
   )
}
export default AdminSignIn;
